import { render, staticRenderFns } from "./statusChoose.vue?vue&type=template&id=48c8e026"
import script from "./statusChoose.vue?vue&type=script&lang=js"
export * from "./statusChoose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports